import { useEffect, useState } from "react";
import SectionHeader from "../components/ui/SectionHeader";
import { LoadingCard } from "../components/ui/LoadingPlaceholder";
import { fetchRealizations } from "../services/publicApi";

function RealizationsPage() {
  const [realizations, setRealizations] = useState([]);
  const [status, setStatus] = useState({ type: "loading", message: "" });

  useEffect(() => {
    let mounted = true;

    async function loadRealizations() {
      setStatus({ type: "loading", message: "" });
      try {
        const response = await fetchRealizations();
        if (!mounted) return;
        setRealizations(response?.items || []);
        setStatus({ type: "idle", message: "" });
      } catch (error) {
        if (!mounted) return;
        setStatus({ type: "error", message: "Realizace se teď nepodařilo načíst." });
      }
    }

    loadRealizations();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section className="page-section">
      <div className="shell">
        <SectionHeader kicker="Realizace" title="Ukázky dokončené práce">
          Fotky mají ukázat výsledek práce. Proto je nechávám jednoduše a bez těžkých efektů.
        </SectionHeader>

        <div className="mt-10 grid gap-6 md:grid-cols-3">
          {status.type === "loading" && !realizations.length
            ? Array.from({ length: 6 }).map((_, index) => <LoadingCard key={`realization-loading-${index}`} imageHeight="h-64" />)
            : realizations.map((item) => (
            <article key={item.title} className="card overflow-hidden">
              <img src={item.image} alt={item.title} className="h-64 w-full object-cover" />
              <div className="p-5">
                <h2 className="text-lg font-bold text-white">{item.title}</h2>
                <p className="mt-1 text-sm text-slate-400">{item.place}</p>
              </div>
            </article>
          ))}
        </div>
        {status.type === "error" && (
          <p className="mt-5 text-sm text-slate-400">{status.message}</p>
        )}
        {status.type !== "loading" && !realizations.length && status.type !== "error" && (
          <p className="mt-5 text-sm text-slate-400">V databázi nejsou žádné realizace.</p>
        )}
      </div>
    </section>
  );
}

export default RealizationsPage;
